const STEPS = {
  INIT: 0,
  CREATE_CAMPAIGN: 1,
  CREATE_ASSETS: 2,
  UPLOAD: 3,
  SUCCESS: 4,
};

const deliveries = {
  state: {
    step: STEPS.INIT,
    campaign: null,
    campaignIsNew: false,
    assetActions: null,
    assets: null,
    goingBackwards: false,
    oldAssetsSearchCriteria: undefined,
  },
  reducers: {
    setOldAssetsSearchCriteria: (state, searchCriteria) => {
      return { ...state, oldAssetsSearchCriteria: searchCriteria };
    },
    reset: (state) => {
      return {
        step: STEPS.INIT,
        campaign: null,
        campaignIsNew: false,
        assetActions: null,
        assets: null,
        goingBackwards: true,
      };
    },
    goBack: (state) => {
      return state.step === STEPS.CREATE_ASSETS && state.campaignIsNew
        ? {
            ...state,
            step: STEPS.CREATE_CAMPAIGN,
            goingBackwards: true,
          }
        : {
            ...state,
            step: STEPS.INIT,
            campaign: null,
            campaignIsNew: false,
            goingBackwards: true,
          };
    },
    onNoCampaign: (state) => {
      return {
        ...state,
        step: STEPS.CREATE_CAMPAIGN,
        goingBackwards: false,
      };
    },
    onCampaignCreate: (state, { campaign }) => {
      return {
        ...state,
        step: STEPS.CREATE_ASSETS,
        campaignIsNew: true,
        campaign,
        goingBackwards: false,
      };
    },
    onCampaignSelect: (state, campaign) => {
      return {
        ...state,
        step: STEPS.CREATE_ASSETS,
        campaignIsNew: false,
        campaign,
        goingBackwards: false,
      };
    },
    upload: (state, assetActions) => {
      return {
        ...state,
        step: STEPS.UPLOAD,
        assetActions,
        goingBackwards: false,
      };
    },
    success: (state, assets) => {
      return {
        ...state,
        step: STEPS.SUCCESS,
        assets,
        goingBackwards: false,
      };
    },
  },
};

export default deliveries;
export { STEPS };
